/* eslint-disable import/no-dynamic-require */
/* eslint-disable global-require */
import { EVENT_BANNERS } from 'appenv';

export default EVENT_BANNERS.right.map(({ src, type, href }) => ({
  src: src.startsWith('http') ? src : require(`assets/608/${src}`),
  type,
  href,
}));
